export const allowedHtmlRegex = /^(p|div|span|ul|ol|li|figure|img|a|b|i|u|s|em|strong|)$/

export const allowedStylesRegex =
  /^(background-color|color|display|float|height|list-style|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|min-height|min-width|padding|padding-bottom|padding-left|padding-right|padding-top|position|text-align|text-decoration|text-transform|vertical-align|width)$/
